import React, { Fragment, useEffect, useRef, useState } from "react";
import { Select as AntSelect, Cascader, Input } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Select,
  MenuItem,
  TextField,
  TextareaAutosize,
  CircularProgress,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  fetchBusinessUnits,
  fetchBusinessUnit,
} from "../../services/orgService";
import type { DatePickerProps } from "antd";
import { DatePicker, Space } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  emissionScopeService,
  getAllUomsService,
  getCurrencyUomService,
  getEmissionCurrencyService,
  getEmissionFactorsHierarchy,
  getEmissionFactorsService,
  getEmissionSourcesData,
  moduletypesbygroups,
} from "../../services/emissionService";
import {
  createAssetService,
  getAssetService,
} from "../../services/assetService";
import { toastMessage } from "../../helper";
import {
  ASSET_DROPDOWN_TARGET_NAME,
  ASSET_REDUCER,
  MAP_ASSET_TO,
} from "../../constants/enums";
import { updateAssetService } from "../../services/assetService";

dayjs.extend(customParseFormat);
const styles = (theme: any) => ({
  ".MuiOutlinedInput-notchedOutline": {
    border: "1px solid #D7DFE9",
    borderRadius: "8px",
    height: "3rem",
  },
  "&:hover": {
    ".MuiOutlinedInput-notchedOutline": {
      border: "2px solid #59CE90 !important",
    },
  },
});
const AssetCreation = (props: any) => {
  const {
    setStep,
    dispatch,
    targetState,
    isSubmit,
    setIsSubmit,
    setActiveSection,
    categoryData,
    scope,
    categoryPreferences,
  } = props;
  const { id } = useParams();
  let isEdit = !!id;
  const { state } = useLocation();
  const navigate = useNavigate();
  const sections = useRef<HTMLDivElement[]>([]);
  const [active, setActive] = useState("");
  const [emissionSources, setEmissionSources] = useState<any>([
    //   { id: 1, name: "Custom emission source" },
    //   { id: 2, name: "Based on activity data" },
    //   // { id: 3, name: "four wheeeler" },
  ]);
  const [selectedFactorSources, setSelectedFactorSources] = useState(
    undefined as any
  );
  const [selectedEmissionMethods, setSelectedEmissionMethods] = useState(
    undefined as any
  );
  const [selectedActivityData, setSelectedActivityData] = useState(
    undefined as any
  );
  const [selectedUom, setSelectedUom] = useState(undefined as any);
  const [isLoading, setIsLoading] = useState(false);
  const [mapAssetTo, setMapAssetTo] = useState<any>([
    { id: 1, name: "Custom emission source", value: "Custom emission source" },
    { id: 2, name: "Based on activity data", value: "Based on activity data" },
  ]);
  const { t, i18n } = useTranslation();
  // const [scope, setScope] = useState();
  const {
    localCode,
    ownerShip,
    emissionCategory,
    emissionMethod,
    emissionType,
    emissionSubType,
    type,
    description,
    location,
    department,
    departmentName,
    category,
    categoryName,
    sourceValue,
    currency,
    currencyName,
    emissionSource,
    emissionSubSource,
    engine,
    fuel,
    country,
    uom,
    uomName,
    noOfUnits,
    value,
    notes,
    sourceLink,
    name,
  } = targetState;
  const mandatoryFields = ["localCode", "ownerShip", "type"];
  const [isMandatoryFieldsFilled, setIsMandatoryFieldsFilled] = useState(false);

  const [ownershipTypes, setOwnershipType] = useState([
    { id: 1, name: "Company Owned", value: "Company_Owned" },
    { id: 2, name: "Leased", value: "Leased" },
    { id: 3, name: "Third Party Owned", value: "Third_Party_Owned" },
  ]);
  const [assetTypes, setAssetType] = useState([
    { id: 1, name: "Vehicle" },
    { id: 2, name: "Equipment" },
    { id: 3, name: "Building" },
    { id: 4, name: "Furniture" },
  ]);
  const [departments, setDepartments] = useState([
    { id: 2379, name: "Transport" },
    { id: 2380, name: "Procurement" },
    { id: 2381, name: "Infrastructure" },
  ]);
  const [categories, setCategories] = useState<any>([
    { id: 2382, name: "Electronics" },
    { id: 2383, name: "IT Equips" },
    { id: 2384, name: "Office Equip" },
    { id: 2385, name: "Heavy Vehicles" },
    { id: 2386, name: "Vendor Vehicle" },
  ]);
  const [currencies, setCurrencies] = useState<any>([]);
  const [selectedCategoryPreference, setselectedCategoryPreference] =
    useState<any>([]);
  const [emissionFactorSources, setEmissionFactorSources] = useState<any>([]);
  const [methods, setMethods] = useState<any>([]);
  const [activityData, setActivityData] = useState<any>([]);
  const [uoms, setUoms] = useState<any>([]);

  const getUomName = (symbol: string) => {
    if (symbol.includes("CO2/")) {
      return symbol.split("CO2/")[1];
    } else if (symbol.includes("CO2e/")) {
      return symbol.split("CO2e/")[1];
    } else return symbol;
  };
  const checkMinus = (e: any) => {
    if (
      e.code === "ArrowDown" ||
      e?.code === "ArrowUp" ||
      e?.code === "Minus"
    ) {
      e.preventDefault();
    }
  };
  const { Option } = AntSelect;

  const getSelectedActivityData = (
    emissionsource: any,
    emission_source_sub_type: any,
    engine_type: any,
    fuel: any
  ) => {
    if (activityData?.length) {
      const selectedActivity = activityData?.find((each: any) => {
        return (
          each?.emissionsource === parseInt(emissionsource) &&
          (emission_source_sub_type === "undefined" ||
            emission_source_sub_type === "null" ||
            !emission_source_sub_type ||
            each?.emission_source_sub_type?.toString() ===
              emission_source_sub_type?.toString()) &&
          (!fuel || each?.fuel === fuel) &&
          (!engine_type || each?.engine_type === engine_type)
        );
      });
      setSelectedActivityData(selectedActivity?.label);
    }
  };

  useEffect(() => {
    const selectedMethod = methods
      ?.filter((each: any) => each.id == emissionMethod)
      .map((eachMp: any) => eachMp.name);
    setSelectedEmissionMethods(selectedMethod?.[0] || []);
    isEdit && setSelectedFactorSources(getEmissionSourceName());

    // const selectedActData = activityData.find(
    //   (each: any) => each.emissionsource === emissionSource
    // )
    //   ? activityData.find((each: any) => each.emissionsource === emissionSource)
    //       .label
    //   : "" || undefined;
    // setSelectedActivityData(selectedActData);
    isEdit &&
      getSelectedActivityData(
        targetState.emissionSource,
        targetState.emissionSubSource,
        targetState.engine,
        targetState.fuel
      );
  }, [emissionMethod, emissionSource, activityData, emissionCategory]);

  const dispatchSelected = (targetName: any, value: any) => {
    dispatch({
      type: ASSET_REDUCER.SET_SELECTED_DROPDOWN,
      payload: {
        name: targetName,
        value,
      },
    });
  };
  const clearSelectedUoms = (targetName: any) => {
    // clear for uoms and no bottom dropdown to call
    dispatchSelected(targetName, {
      uom: null,
      uomName: null,
    });
    setSelectedUom(undefined);
  };
  const clearSelectedActivityData = (targetName: any) => {
    // clear for Activity - data and call its bottom dropdown
    // updateDropdown(targetName,{emissionMethod : null});
    dispatchSelected(targetName, {
      emissionSource: null,
      emissionSubSource: null,
      engine: null,
      fuel: null,
    });
    setSelectedActivityData(undefined);
  };
  const clearSelectedMethods = (targetName: any) => {
    // clear for Methods and call its bottom dropdown
    dispatchSelected(targetName, {
      emissionMethod: null,
    });
    setSelectedEmissionMethods(undefined);
  };
  const clearSelectedEmissionFactorSources = (targetName: any) => {
    // clear for factor source and call its bottom dropdown
    dispatchSelected(targetName, {
      emissionType: null,
      emissionSubType: null,
    });
    setSelectedFactorSources(undefined);
  };

  const clearAllBottomDropdownSelected = (targetName: any) => {
    switch (targetName) {
      case ASSET_DROPDOWN_TARGET_NAME.SCOPE_CATOGRIES:
        {
          // dropdowns to be clear 1. source,methods,activity data, uoms
          clearSelectedEmissionFactorSources(
            ASSET_DROPDOWN_TARGET_NAME.EMISSION_FACTOR_SOURCES
          );
          clearSelectedMethods(ASSET_DROPDOWN_TARGET_NAME.METHODS);
          clearSelectedActivityData(ASSET_DROPDOWN_TARGET_NAME.ACTIVITY_DATA);
          clearSelectedUoms(ASSET_DROPDOWN_TARGET_NAME.UOMS);
        }
        break;
      case ASSET_DROPDOWN_TARGET_NAME.EMISSION_FACTOR_SOURCES:
        {
          // dropdowns to be clear 1. methods,activity data, uoms
          clearSelectedMethods(ASSET_DROPDOWN_TARGET_NAME.METHODS);
          clearSelectedActivityData(ASSET_DROPDOWN_TARGET_NAME.ACTIVITY_DATA);
          clearSelectedUoms(ASSET_DROPDOWN_TARGET_NAME.UOMS);
        }
        break;
      case ASSET_DROPDOWN_TARGET_NAME.METHODS:
        {
          // dropdowns to be clear 1. activity data, uoms
          clearSelectedActivityData(ASSET_DROPDOWN_TARGET_NAME.ACTIVITY_DATA);
          clearSelectedUoms(ASSET_DROPDOWN_TARGET_NAME.UOMS);
        }
        break;
      case ASSET_DROPDOWN_TARGET_NAME.ACTIVITY_DATA:
        {
          // dropdowns to be clear 1. uoms
          clearSelectedUoms(ASSET_DROPDOWN_TARGET_NAME.UOMS);
        }
        break;
      default:
        break;
    }
  };
  const onChangeAssetsDropdown = (
    e: any,
    targetName: any,
    isClearBottomDropdown?: any
  ) => {
    let value = e;
    let flag = true;
    if (targetName === ASSET_DROPDOWN_TARGET_NAME.DEPARTMENT) {
      value = {};
      value.department = e;
      value.departmentName = departments.find(
        (eachDep: any) => eachDep.id === e
      )?.name;
    } else if (targetName === ASSET_DROPDOWN_TARGET_NAME.CATEGORY) {
      value = {};
      value.category = e;
      value.categoryName = categories.find(
        (eachDep: any) => eachDep.id === e
      )?.name;
    } else if (targetName === ASSET_DROPDOWN_TARGET_NAME.CURRENCY) {
      value = {};
      value.currency = e;
      value.currencyName = currencies.find(
        (eachCur: any) => eachCur.id === e
      )?.symbol;
    } else if (targetName === ASSET_DROPDOWN_TARGET_NAME.SCOPE_CATOGRIES) {
      value = {};
      value.emissionCategory = e;
      // value.emissionCategory = e;
      const selectedCategoryPreference = categoryPreferences?.find(
        (preference: any) =>
          preference[
            localStorage.getItem("protocol") == "ghg"
              ? "ghgCategory"
              : "category"
          ] === e
      );
      const selectedCategoryData = categoryData?.find(
        (eachCategoryData: any) =>
          eachCategoryData.id === value.emissionCategory
      );
      if (selectedCategoryData?.scope) {
        value.scope = selectedCategoryData?.scope;
      }
      setselectedCategoryPreference(
        selectedCategoryPreference ? [selectedCategoryPreference] : []
      );
      const allSources: any = [];
      const sourcesList = selectedCategoryPreference?.emissionSources?.map(
        (sources: any) => ({
          name: sources?.typeName + "-" + sources?.subTypeName,
          id: sources?.type + "-" + sources?.subType,
        })
      );
      sourcesList && allSources.push(...sourcesList);
      setEmissionFactorSources(allSources);
    } else if (
      targetName === ASSET_DROPDOWN_TARGET_NAME.EMISSION_FACTOR_SOURCES
    ) {
      value = {};
      const [type, subType] = e.split("-");
      value.emissionType = parseInt(type);
      value.emissionSubType = parseInt(subType);
      let categoryPref = selectedCategoryPreference;
      if (!selectedCategoryPreference.length) {
        categoryPref = categoryPreferences?.filter(
          (preference: any) =>
            preference.category ==
            parseInt(state.assetDetailedItem.emission_category_id)
        );
      }
      const filteredMethods = categoryPref[0]?.methods?.filter(
        (method: any) =>
          method.type === parseInt(type) &&
          method.sub_type === parseInt(subType)
      );
      const emissionFactorSource = emissionFactorSources
        ?.filter((each: any) => each.id === e)
        .map((eachMp: any) => eachMp.name);
      if (selectedFactorSources === emissionFactorSource[0]) {
        flag = false;
      }
      setSelectedFactorSources(emissionFactorSource[0]);
      setMethods(filteredMethods);
    } else if (targetName === ASSET_DROPDOWN_TARGET_NAME.METHODS) {
      value = {};
      const [methodId, type, sub_type] = e.split("-");
      let params: any = {};
      value.emissionMethod = parseInt(methodId);
      let categoryPref = selectedCategoryPreference;
      if (!selectedCategoryPreference.length) {
        categoryPref = categoryPreferences?.filter(
          (preference: any) =>
            preference.category ==
            parseInt(state.assetDetailedItem.emission_category_id)
        );
      }
      params.categoryId =
        (localStorage.getItem("protocol") == "ghg"
          ? categoryPref?.[0]?.ghgCategory
          : categoryPref?.[0]?.category) || null;
      params.method = methodId;
      params.type = type;
      params.subtype = sub_type;
      params.fromAsset = true;
      const selectedMethod = methods
        ?.filter(
          (each: any) =>
            each.id == methodId &&
            each.type == type &&
            each.sub_type == sub_type
        )
        .map((eachMp: any) => eachMp.name);
      if (selectedMethod[0] === selectedEmissionMethods) {
        flag = false;
      }
      setSelectedEmissionMethods(selectedMethod[0]);
      if (selectedMethod[0]) {
        getEmissionFactorsService(params).then((res: any) => {
          let allActivityData =
            (res?.data[0]?.level1_status?.length
              ? res.data[0].level1_status
              : res?.data[0]?.level2_status?.length
              ? res.data[0].level2_status
              : res?.data[0]?.level3_status?.length
              ? res.data[0].level3_status
              : null) ?? undefined;

          const activityDataList = allActivityData.map((item: any) => {
            if (item.children && item.children.length > 0) {
              const subItems = item.children.map((subItem: any) => ({
                label: `${
                  item.label ? item.label : item.emissionsourcename
                } - ${subItem.label}`,
                emissionsource: item.emissionsource,
                emission_source_sub_type: item.emission_source_sub_type
                  ? item.emission_source_sub_type
                  : item.emissionsourcesubtype,
                value: subItem.value,
                fuel: subItem.fuel,
                engine_type: subItem.engine_type,
                uoms: item.uoms,
              }));
              return subItems;
            } else {
              return {
                label: item.label ? item.label : item.emissionsourcename,
                emissionsource: item.emissionsource,
                emission_source_sub_type: item.emission_source_sub_type
                  ? item.emission_source_sub_type
                  : item.emissionsourcesubtype,
                uoms: item.uoms,
              };
            }
          });
          const flattenedActivityData = activityDataList.flat();
          setActivityData(flattenedActivityData);
        });
      }
    } else if (targetName === ASSET_DROPDOWN_TARGET_NAME.ACTIVITY_DATA) {
      value = {};
      const [emissionsource, emission_source_sub_type, children_value] =
        e.split(":");
      let fuelType;
      let engineType;

      // const selectedActivity = activityData.find((each: any) => {
      //   console.log(each);
      //   return each.emissionsource === parseInt(emissionsource) &&
      //   ((emission_source_sub_type === "undefined") || (each.emission_source_sub_type).toString() === emission_source_sub_type) &&
      //   ((children_value === "undefined") || (each.value).toString() === children_value)
      // });

      // console.log(selectedActivity);
      // setSelectedActivityData(selectedActivity.label);
      if (children_value && children_value.length) {
        if (children_value.includes("-")) {
          if (children_value.charAt(0).match(/\d/)) {
            [engineType, fuelType] = children_value.split("-");
            fuelType = parseInt(fuelType);
            engineType = parseInt(engineType);
          } else {
            const fuel = children_value.split("-");
            fuelType = parseInt(fuel[1]);
          }
        } else {
          engineType = parseInt(children_value);
        }
      }
      value.emissionSource = parseInt(emissionsource);
      value.emissionSubSource = parseInt(emission_source_sub_type);
      value.engine = engineType;
      value.fuel = fuelType;
      getSelectedActivityData(
        emissionsource,
        emission_source_sub_type,
        engineType,
        fuelType
      );
      let reqActivity = activityData;
      if (!reqActivity.length) {
        let categoryPref = selectedCategoryPreference;
        if (!selectedCategoryPreference.length) {
          categoryPref = categoryPreferences?.filter(
            (preference: any) =>
              preference.category ===
              parseInt(state.assetDetailedItem.emission_category_id)
          );
        }
        const params: any = {
          categoryId:
            localStorage.getItem("protocol") == "ghg"
              ? categoryPref?.[0]?.ghgCategory
              : categoryPref?.[0]?.category,
          method: state.assetDetailedItem.emission_method_id,
          type: state.assetDetailedItem.emission_type_id,
          subtype: state.assetDetailedItem.emission_sub_type_id,
        };
        params.fromAsset = true;
        if (categoryPref[0]) {
          getEmissionFactorsService(params).then((res: any) => {
            // const allActivityData = res.data;
            // const activityDataList = allActivityData.map((item: any) => {
            //   if (item.children && item.children.length > 0) {
            //     const subItems = item.children.map((subItem: any) => ({
            //       label: `${
            //         item.label ? item.label : item.emissionsourcename
            //       } - ${subItem.label}`,
            //       emissionsource: item.emissionsource,
            //       emission_source_sub_type: item.emission_source_sub_type
            //         ? item.emission_source_sub_type
            //         : item.emissionsourcesubtype,
            //       value: subItem.value,

            //       uoms: item.uoms,
            //     }));
            //     return subItems;
            //   } else {
            //     return {
            //       label: item.label ? item.label : item.emissionsourcename,
            //       emissionsource: item.emissionsource,
            //       emission_source_sub_type: item.emission_source_sub_type
            //         ? item.emission_source_sub_type
            //         : item.emissionsourcesubtype,
            //       uoms: item.uoms,
            //     };
            //   }
            // });
            // const flattenedActivityData = activityDataList.flat();
            // const selectedActData = flattenedActivityData.find(
            //   (each: any) => each.emissionsource === emissionSource
            // )
            //   ? activityData.find(
            //       (each: any) => each.emissionsource === emissionSource
            //     ).label
            //   : "" || undefined;
            // setSelectedActivityData(selectedActData);
            // getSelectedActivityData(emissionSource, emissionSubSource, engine, fuel);
            // setActivityData(flattenedActivityData);

            let allActivityData =
              (res?.data[0]?.level1_status?.length
                ? res.data[0].level1_status
                : res?.data[0]?.level2_status?.length
                ? res.data[0].level2_status
                : res?.data[0]?.level3_status?.length
                ? res.data[0].level3_status
                : null) ?? undefined;
            const activityDataList = allActivityData.map((item: any) => {
              if (item.children && item.children.length > 0) {
                const subItems = item.children.map((subItem: any) => ({
                  label: `${
                    item.label ? item.label : item.emissionsourcename
                  } - ${subItem.label}`,
                  emissionsource: item.emissionsource,
                  emission_source_sub_type: item.emission_source_sub_type
                    ? item.emission_source_sub_type
                    : item.emissionsourcesubtype,
                  value: subItem.value,
                  fuel: subItem.fuel,
                  engine_type: subItem.engine_type,
                  uoms: item.uoms,
                }));
                return subItems;
              } else {
                return {
                  label: item.label ? item.label : item.emissionsourcename,
                  emissionsource: item.emissionsource,
                  emission_source_sub_type: item.emission_source_sub_type
                    ? item.emission_source_sub_type
                    : item.emissionsourcesubtype,
                  uoms: item.uoms,
                };
              }
            });
            const flattenedActivityData = activityDataList.flat();
            setActivityData(flattenedActivityData);
            reqActivity = flattenedActivityData;
            const selectedActivitiesData = reqActivity?.find((item: any) => {
              return (
                item.emissionsource === parseInt(emissionsource) &&
                (!item.emission_source_sub_type ||
                  item.emission_source_sub_type ===
                    parseInt(emission_source_sub_type) ||
                  !item.emissionsourcesubtype ||
                  item.emissionsourcesubtype ===
                    parseInt(emission_source_sub_type)) &&
                (!item.children ||
                  !item.children.value ||
                  item.children.value === children_value)
              );
            });
            if (selectedActivityData === selectedActivitiesData.label) {
              flag = false;
            }
            const uoms = selectedActivitiesData
              ? selectedActivitiesData.uoms
              : [];
            setUoms(uoms);
          });
        }
      } else {
        const selectedActivitiesData = reqActivity?.find((item: any) => {
          return (
            item.emissionsource === parseInt(emissionsource) &&
            (!item.emission_source_sub_type ||
              item.emission_source_sub_type ===
                parseInt(emission_source_sub_type) ||
              !item.emissionsourcesubtype ||
              item.emissionsourcesubtype ===
                parseInt(emission_source_sub_type)) &&
            (!item.children ||
              !item.children.value ||
              item.children.value === children_value)
          );
        });
        if (selectedActivityData === selectedActivitiesData.label) {
          flag = false;
        }
        const uoms = selectedActivitiesData ? selectedActivitiesData.uoms : [];
        setUoms(uoms);
      }
    } else if (targetName === ASSET_DROPDOWN_TARGET_NAME.UOMS) {
      value = {};
      const [uomId, uomName] = e.split(":");
      value.uom = uomId;
      setSelectedUom(getUomName(uomName));
      value.uomName = uomName;
    }
    isClearBottomDropdown && flag && clearAllBottomDropdownSelected(targetName);
    dispatch({
      type: ASSET_REDUCER.SET_SELECTED_DROPDOWN,
      payload: { name: targetName, value: value },
    });
  };
  const onChangeTextField = (e: any) => {
    dispatch({
      type: ASSET_REDUCER.SET_INPUT_FIELD,
      payload: { name: e.target.name, value: e.target.value },
    });
  };
  const saveOrEditAsset = (e?: any) => {
    setIsLoading(true);
    let scopeMap: any = {
      70: 1,
      71: 2,
      72: 3,
    };
    if (isEdit) {
      const reqData = {
        name: targetState.name,
        locationCode: targetState.localCode,
        code: targetState.localCode,
        status: state.assetDetailedItem.status,
        ownerShip: targetState.ownerShip,
        type: targetState.type,
        description: targetState.description,
        location: targetState.location,
        department: targetState.department,
        departmentName: targetState.departmentName,
        category: categoryPreferences.filter(
          (item: any) =>
            item["ghgCategory"] == targetState.category ||
            item.category == targetState.category
        )[0].category,
        scope: scopeMap[targetState.scope] || null,
        categoryName: targetState.categoryName,
        emissionSourceName: activityData.find(
          (each: any) => each.emissionsource === emissionSource
        ).label,
        emissionSource: targetState.emissionSource,
        emissionSubSource: targetState.emissionSubSource,
        fuel: targetState.fuel,
        // fuel_id: state.fuel_id,
        engine: targetState.engine,
        // engine_id: state.engine_id,
        uomName: targetState.uomName,
        noOfUnits: 1.0,
        value: targetState.value,
        currency: targetState.currency,
        currencyName: targetState.currencyName,
        notes: targetState.notes,
        emissionCategoryName: categoryData[0]?.name.split("-")[1],
        emissionCategory: targetState.emissionCategory,
        emissionType: targetState.emissionType,
        emissionTypeName: emissionFactorSources
          .filter(
            (eachType: any) =>
              eachType.id === `${emissionType}-${emissionSubType}`
          )[0]
          .name.split("-")[0],
        emissionSubTypeName: emissionFactorSources
          .filter(
            (eachType: any) =>
              eachType.id === `${emissionType}-${emissionSubType}`
          )[0]
          .name.split("-")[1],
        emissionSubType: targetState.emissionSubType,
        emissionMethodName: methods?.find(
          (each: any) => each?.id === emissionMethod
        ).name,
        emissionMethod: targetState.emissionMethod,
        uom: targetState.uom,
      };
      updateAssetService({ ...reqData, scope }, id || "")
        .then((res: any) => {
          toastMessage("Asset Updated Successfully", "success");
          navigate("/assets");
        })
        .catch((err) => {
          console.log(err);
          toastMessage(err.response.data.message, "error");
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      let data = { ...targetState };
      data.emissionCategory = categoryPreferences.filter(
        (item: any) =>
          item["ghgCategory"] == targetState.emissionCategory ||
          item.category == targetState.emissionCategory
      )[0].category;
      createAssetService(data)
        .then((res: any) => {
          toastMessage("Asset Created Successfully", "success");
          navigate("/assets");
        })
        .catch((err) => {
          console.log(err);
          toastMessage(err.response.data.message, "error");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  const handleScroll = (event: any) => {
    const pageYOffset = window.scrollY;
    const b = document.getElementById("basicInfo")?.getBoundingClientRect();
    const a = document.getElementById("assetMapping")?.getBoundingClientRect();
    const i = document
      .getElementById("additionalInfo")
      ?.getBoundingClientRect();
    if (b && b.top >= 0 && b.bottom >= 56) {
      setActive("basicInfo");
      setActiveSection("basicInfo");
    } else if (a && a.top >= 0 && b && b.bottom <= 56) {
      setActive("assetMapping");
      setActiveSection("assetMapping");
    } else if (i && i.top >= 0 && a && a.bottom <= 56) {
      setActive("additionalInfo");
      setActiveSection("additionalInfo");
    }
  };

  const getEmissionSourceName = () => {
    const reqEmissionSource =
      selectedCategoryPreference?.length &&
      selectedCategoryPreference[0]?.emissionSources?.find(
        (each: any) =>
          each.type === emissionType && each.subType === emissionSubType
      );
    return reqEmissionSource
      ? `${reqEmissionSource.typeName}-${reqEmissionSource.subTypeName}`
      : undefined;
  };
  useEffect(() => {
    const areAllFilled = mandatoryFields.every(
      (fieldName) => targetState[fieldName]
    );
    let areDropdownSelected =
      selectedFactorSources?.length &&
      selectedActivityData?.length &&
      selectedEmissionMethods?.length &&
      selectedUom?.length &&
      uom;
    setIsMandatoryFieldsFilled(areAllFilled && areDropdownSelected);
  }, [
    targetState,
    selectedFactorSources,
    selectedActivityData,
    selectedEmissionMethods,
    selectedUom,
  ]);

  useEffect(() => {
    //departments
    if (!isEdit) {
      moduletypesbygroups({ moduleGroup: "Asset Department" })
        .then((res) => {
          let departments = res.data;
          moduletypesbygroups({ moduleGroup: "Asset Category" }).then(
            (res1) => {
              let categories = res1.data;
              setCategories(categories);
              setDepartments(departments);
              getEmissionCurrencyService().then((res2: any) => {
                let currencies = res2.data;
                setCurrencies(res2.data);
                const a = isEdit ? ownerShip : ownershipTypes[0].value;
                dispatch({
                  type: ASSET_REDUCER.SET_INITIAL_STATE,
                  payload: {
                    department: departments[0].id,
                    departmentName: departments[0].name,
                    category: categories[0].id,
                    categoryName: categories[0].name,
                    currency: currencies[0].id,
                    currencyName: currencies[0].symbol,
                    ownerShip: a,
                    type: assetTypes[0].name,
                  },
                });
              });
            }
          );
        })
        .catch((err) => {
          console.log(err);
          toastMessage(err.response.data.message, "error");
        });
    } else {
      moduletypesbygroups({ moduleGroup: "Asset Category" }).then((res) => {
        let categories = res.data;
        setCategories(categories);
      });
    }
  }, [isEdit]);

  useEffect(() => {
    if (isEdit) {
      getEmissionCurrencyService()
        .then((res) => {
          setCurrencies(res.data);
        })
        .catch((err) => {
          console.log("err");
        });
      const assetDetails = state.assetDetailedItem;
      // for input textfields
      const typeMapping: any = {
        localCode: "local_code",
        name: "name",
        description: "description",
        location: "location",
        noOfUnits: "no_of_units",
        notes: "notes",
        value: "value",
      };
      Object.keys(typeMapping).map((each: any) => {
        dispatch({
          type: ASSET_REDUCER.SET_INPUT_FIELD,
          payload: {
            name: each,
            value: assetDetails[typeMapping[each]],
          },
        });
      });
      const isPresent: number = categoryData.findIndex((each: any) => {
        return each.id === parseInt(assetDetails.emission_category_id);
      });
      const dropdownMapping: any = {
        ownerShip: assetDetails.owner_ship,
        type: assetDetails.type,
        scopeCategories:
          isPresent === -1 ? null : parseInt(assetDetails.emission_category_id),
        Department: assetDetails.department,
        Category: assetDetails.category,
        emissionFactorSources: `${assetDetails.emission_type_id}-${assetDetails.emission_sub_type_id}`,
        methods: `${assetDetails.emission_method_id}-${assetDetails.emission_type_id}-${assetDetails.emission_sub_type_id}`,
        activityData: `${assetDetails.emission_source_id}:${assetDetails.emission_sub_source_id}:${assetDetails.engine_id}`,
        uoms: `${assetDetails.uom}:${assetDetails.uom_name}`,
        currency: `${assetDetails.currency}`,
        currencyName: `${assetDetails.currency_name}`,
      };
      Object.keys(dropdownMapping).map((key: any) => {
        onChangeAssetsDropdown(dropdownMapping[key], key);
      });
      if (isPresent === -1) {
        clearSelectedUoms(ASSET_DROPDOWN_TARGET_NAME.UOMS);
      }
    }
  }, [isEdit]);

  useEffect(() => {
    sections.current = Array.from(document.querySelectorAll("[data-section]"));
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Fragment>
      <div
        className="pw-activity-data-main w-55v overflow-y-auto flex flex-col gap-10"
        onScroll={handleScroll}
      >
        <div>
          <div className="pw-input-label pw-create-label">
            {isEdit ? "Edit Assets" : "Add Assets"}
          </div>
          <div className="flex flex-row justify-between items-center pw-border-bottom pb-2">
            <div className="flex flex-row gap-1">
              <p className="text-sm text-neutral-600">
                {t("Please provide the necessary information to add assets.")}
              </p>
            </div>
          </div>
        </div>
        <div
          data-section
          id="basicInfo"
          className="bg-white rounded-lg p-6 flex flex-col gap-10 items-start justify-start self-stretch shrink-0 relative"
        >
          <div className="text-neutral-500 text-left uppercase relative self-stretch flex items-center justify-start">
            {t("Basic info")}
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Asset ID")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>

            <TextField
              onKeyDown={checkMinus}
              type="text"
              variant="outlined"
              placeholder={t("Asset ID")}
              size="small"
              name="localCode"
              value={localCode}
              onChange={(e) => onChangeTextField(e)}
              className="pw-width-100 pw-input-field pw-input-text"
              sx={styles}
              disabled={isEdit}
            />
          </div>

          <div className="flex flex-row gap-10 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative overflow-hidden">
              <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
                <div className="text-neutral-600 text-left relative">
                  {t("Asset Name")}
                </div>
              </div>

              <TextField
                type="text"
                variant="outlined"
                placeholder={t("Asset Name")}
                size="small"
                name="name"
                value={name}
                onChange={(e) => onChangeTextField(e)}
                className="pw-width-100 pw-input-field pw-input-text"
                sx={styles}
              />
            </div>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Ownership")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 384 }}
              className="pw-source-select"
              id="pw-e2e-ownership"
              placeholder={t("Ownership")}
              onChange={(e) => onChangeAssetsDropdown(e, "ownerShip")}
              value={ownerShip}
            >
              {ownershipTypes?.map(
                ({
                  name,
                  id,
                  value,
                }: {
                  name: String;
                  id: number;
                  value: String;
                }) => (
                  <Option key={id} value={value} className="pw-menu-item">
                    {name}
                  </Option>
                )
              )}
            </AntSelect>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Asset Type")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>

            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 384 }}
              className="pw-source-select"
              id="pw-e2e-assettype"
              placeholder="Asset Type"
              onChange={(e) => onChangeAssetsDropdown(e, "type")}
              value={type}
            >
              {assetTypes?.map(({ name, id }: { name: String; id: number }) => (
                <Option key={id} value={name} className="pw-menu-item">
                  {name}
                </Option>
              ))}
            </AntSelect>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start self-stretch shrink-0 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Description")}
              </div>
            </div>

            <TextareaAutosize
              placeholder={t("add description here")}
              name="description"
              value={description}
              onChange={(e) => onChangeTextField(e)}
              className="pw-width-100 pw-input-field pw-address"
            />

            <div className="flex flex-row items-center justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-400 text-right relative flex-1">
                {description?.length || 0}/100
              </div>
            </div>
          </div>
        </div>

        <div
          data-section
          id="assetMapping"
          className="bg-white rounded-lg p-6 flex flex-col gap-10 items-start justify-start self-stretch shrink-0 relative"
        >
          <div className="text-neutral-500 text-left uppercase relative self-stretch flex items-center justify-start">
            {t("Asset Mapping")}
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Emission Categories")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>

            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 484 }}
              className="pw-source-select"
              id="pw-e2e-emissioncategory"
              placeholder={t("Emission Categories")}
              // onChange={(e) => onChangeAssetsDropdown(e, "scopeCategories")}
              onChange={(selectedCategoryIds) =>
                onChangeAssetsDropdown(
                  selectedCategoryIds,
                  "scopeCategories",
                  true
                )
              }
              value={emissionCategory || undefined}
              // mode="multiple"
            >
              {categoryData?.map((option: any) => (
                <Option key={option.id} value={option.id}>
                  {option.name}
                </Option>
              ))}
            </AntSelect>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Emission Factor Sources")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 484 }}
              id="pw-e2e-emissionsource"
              className="pw-source-select"
              placeholder={t("Emission Factor Sources")}
              onChange={(e) =>
                onChangeAssetsDropdown(e, "emissionFactorSources", true)
              }
              disabled={!emissionCategory}
              value={selectedFactorSources || undefined}
            >
              {emissionFactorSources.map((option: any) => (
                <Option key={option.id} value={option.id}>
                  {option.name}
                </Option>
              ))}
            </AntSelect>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Log Emission Against")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 484 }}
              id="pw-e2e-logemissionagainst"
              className="pw-source-select"
              placeholder={t("Log Emission Against")}
              onChange={(e) => onChangeAssetsDropdown(e, "methods", true)}
              value={selectedEmissionMethods}
              disabled={!selectedFactorSources}
            >
              {methods?.map(
                (option: any) =>
                  option.selected && (
                    <Option
                      key={option.id}
                      value={
                        option.id + "-" + option.type + "-" + option.sub_type
                      }
                    >
                      {option.name}
                    </Option>
                  )
              )}
            </AntSelect>
          </div>
          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Activity Data")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>
            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 484 }}
              id="pw-e2e-activitydata"
              className="pw-source-select"
              placeholder={t("Activity Data")}
              onChange={(e) => onChangeAssetsDropdown(e, "activityData", true)}
              value={selectedActivityData}
              disabled={!targetState.emissionMethod}
              // onChange={(selectedCategoryIds) => onChangeAssetsDropdown(selectedCategoryIds, "scopeCategories")}
              // mode="multiple"
            >
              {activityData.map((option: any) => (
                <Option
                  key={
                    option.emissionsource +
                    "-" +
                    option.emission_source_sub_type +
                    "-" +
                    option.value
                  }
                  value={
                    option.emissionsource +
                    ":" +
                    option.emission_source_sub_type +
                    ":" +
                    option.value
                  }
                >
                  {option.label}
                </Option>
              ))}
            </AntSelect>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Uoms")}
              </div>
              <div className="pw-mandatory-icon">*</div>
            </div>

            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 484 }}
              id="pw-e2e-assetuom"
              className="pw-source-select"
              placeholder={t("Uoms")}
              onChange={(e) => onChangeAssetsDropdown(e, "uoms")}
              value={selectedUom || undefined}
              disabled={!selectedActivityData}
              // onChange={(selectedCategoryIds) => onChangeAssetsDropdown(selectedCategoryIds, "scopeCategories")}
              // mode="multiple"
            >
              {uoms.map((option: any) => (
                <Option key={option.id} value={option.id + ":" + option.symbol}>
                  {getUomName(option.symbol)}
                </Option>
              ))}
            </AntSelect>
          </div>
        </div>

        <div
          data-section
          id="additionalInfo"
          className="bg-white rounded-lg p-6 flex flex-col gap-10 items-start justify-start self-stretch shrink-0 relative"
        >
          <div className="text-neutral-500 text-left uppercase relative self-stretch flex items-center justify-start">
            {t("Additional info")}
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Location")}
              </div>
            </div>

            <TextField
              type="text"
              variant="outlined"
              placeholder={t("Location")}
              size="small"
              name="location"
              value={location}
              onChange={(e) => onChangeTextField(e)}
              className="pw-width-100 pw-input-field pw-input-text"
              sx={styles}
            />
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Department")}
              </div>
            </div>

            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 384 }}
              id="pw-e2e-assetdepartment"
              className="pw-source-select"
              placeholder={t("Department")}
              onChange={(e) => onChangeAssetsDropdown(e, "Department")}
              value={departmentName}
            >
              {departments?.map(
                ({ name, id }: { name: String; id: number }) => (
                  <Option key={id} value={id} className="pw-menu-item">
                    {name}
                  </Option>
                )
              )}
            </AntSelect>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Category")}
              </div>
            </div>

            <AntSelect
              suffixIcon={<CaretDownOutlined />}
              dropdownStyle={{ minWidth: "25%" }}
              // showSearch
              style={{ width: 384 }}
              id="pw-e2e-assetcategory"
              className="pw-source-select"
              placeholder={t("Category")}
              onChange={(e) => onChangeAssetsDropdown(e, "Category")}
              value={categoryName}
            >
              {categories?.map(({ name, id }: { name: String; id: number }) => (
                <Option key={id} value={id} className="pw-menu-item">
                  {name}
                </Option>
              ))}
            </AntSelect>
          </div>

          <div className="flex flex-row gap-10 items-start justify-start shrink-0 w-96 relative">
            {/* <div className="flex flex-col gap-2 items-start justify-start shrink-0 w-96 relative">
              <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
                <div className="text-neutral-600 text-left relative">
                  {t("No. of units")}
                </div>
              </div>
              <TextField
                onKeyDown={checkMinus}
                type="number"
                variant="outlined"
                placeholder={t("No. of units")}
                size="small"
                name="noOfUnits"
                value={noOfUnits}
                onChange={(e) => onChangeTextField(e)}
                className="pw-width-100 pw-input-field pw-input-text"
                sx={styles}
              />
            </div> */}

            <div className="flex flex-col gap-2 items-start justify-start flex-1 relative">
              <div className="flex flex-row gap-0.5 items-start justify-start shrink-0 relative">
                <div className="text-neutral-600 text-left relative">
                  {t("Value")}
                </div>
              </div>
              <Input
                name="value"
                type="number"
                onKeyDown={checkMinus}
                addonBefore={
                  <AntSelect
                    suffixIcon={<CaretDownOutlined />}
                    // dropdownStyle={{ minWidth: "25%" }}
                    // showSearch
                    style={{ width: 100 }}
                    id="pw-e2e-assetcurrency"
                    // className="pw-source-select"
                    placeholder={t("Currency")}
                    value={
                      typeof currencyName === "string"
                        ? currencyName
                        : currencies.find((each: any) => each.id === currency)
                            ?.symbol
                    }
                    onChange={(e) => onChangeAssetsDropdown(e, "currency")}
                  >
                    {currencies.map((eachCurrency: any) => (
                      <Option key={eachCurrency.id} value={eachCurrency.id}>
                        {eachCurrency.symbol}
                      </Option>
                    ))}
                  </AntSelect>
                }
                value={value}
                onChange={(e) => onChangeTextField(e)}
              />
            </div>
          </div>

          <div className="flex flex-col gap-2 items-start justify-start self-stretch shrink-0 relative">
            <div className="flex flex-row gap-0.5 items-start justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-600 text-left relative">
                {t("Notes")}
              </div>
            </div>

            <TextareaAutosize
              placeholder={t("add notes here")}
              name="notes"
              value={notes}
              onChange={(e) => onChangeTextField(e)}
              className="pw-width-100 pw-input-field pw-address"
            />

            <div className="flex flex-row items-center justify-start self-stretch shrink-0 relative">
              <div className="text-neutral-400 text-right relative flex-1">
                {notes?.length || 0}/100
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-row justify-end pw-bunit-footer w-full gap-6">
        <div
          className="pw-bunit-button-light pw-bunit-button-next text-neutral bg-white font-bold cursor-pointer"
          onClick={() => navigate("/assets")}
        >
          {t("Cancel")}
        </div>
        <button
          // className="pw-bunit-button-primary pw-bunit-button-save text-white cursor-pointer bg-primary"
          className={`pw-bunit-button-primary pw-bunit-button-save text-white ${
            isMandatoryFieldsFilled
              ? isLoading
                ? "text-black bg-neutral-300"
                : "cursor-pointer bg-primary"
              : "text-black bg-neutral-300"
          }`}
          onClick={
            isMandatoryFieldsFilled && !isLoading ? saveOrEditAsset : undefined
          }
          disabled={!isMandatoryFieldsFilled}
        >
          {isLoading ? (
            <div className="flex flex-row gap-2 p-2">
              <span>{t("Saving up")}</span>
              <CircularProgress size={20} />
            </div>
          ) : (
            <span>{t("Save")}</span>
          )}
        </button>
      </div>
    </Fragment>
  );
};

export default AssetCreation;
